import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Layout } from 'antd'
import { useTranslation } from 'react-i18next'

// Views
import Header from '../Components/Header/Scenes'
import FlagManagement from '../../../../../../domain/flag-management/flag-management.component'
import { SideMenu } from '../../../../../../refactory/modules/layout/infrastructure/side-menu/side-menu.component'
import { ModulePerms } from '../../../../../../refactory/modules/access-control/domain/module'
import { Can } from '../../../../../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import LazyLoad from '../../../../LazyLoad'

import './styles.less'
import { useGate } from 'statsig-react'

const LazyLoadJobList = React.lazy(() => import('@/domain/jobs'))
const LazyLoadJobs = React.lazy(() => import('@/domain/flag-management'))
const LazyLoadResources = React.lazy(() => import('@/domain/resource-management'))
const LazyLoadRoutes = React.lazy(() => import('@/domain/routing'))
const LazyLoadRoutesV2Old = React.lazy(() =>
  import('../../../../../../refactory/modules/routing/infrastructure/routing/routing-old.component')
)
const LazyLoadRoutesV2 = React.lazy(() =>
  import('../../../../../../refactory/modules/routing/infrastructure/Routing').then((m) => ({ default: m.Routing }))
)
const LazyLoadSystemParameters = React.lazy(() => import('@/domain/system-parameters'))
const LazyLoadUsers = React.lazy(() => import('@/domain/user-management'))
const LazyLoadMetrics = React.lazy(() => import('@/domain/metrics'))
const LazyLoadAnalytics = React.lazy(() =>
  import('../../../../../../refactory/analytics/infrastructure/analytics-visualization/analytics.component')
)
const LazyLoadMFE = React.lazy(() => import('@/domain/bp'))
const LazyLoadMFEVSN = React.lazy(() => import('@/domain/vision'))
const LazyLoadMFEWMS = React.lazy(() => import('@/domain/alfred'))
const LazyLoadMFESegmenter = React.lazy(() => import('@/domain/segmenter'))
const LazyLoadMFEComanda = React.lazy(() => import('@/domain/venom'))
const LazyLoadMFESage = React.lazy(() => import('@/domain/sage'))
const LazyLoadMFEJonahJameson = React.lazy(() => import('@/domain/jonah-jameson'))
//const LazyLoadActivityLog = React.lazy(() => import('@/domain/activity-log'))
const LazyLoadActivityLog = React.lazy(() =>
  import('../../../../../../refactory/activity-log/infrastructure/get-events/events-visualization.component')
)
const LazyLoadStartStream = React.lazy(() =>
  import('../../../../../../refactory/modules/start-stream/infrastructure/reports.component')
)
const LazyLoadNotAvailable = React.lazy(() =>
  import('../../../../../../refactory/modules/not-available/infrastructure/not-available.component')
)
const LazyLoadRejectItemsCreatePostDelivery = React.lazy(() =>
  import(
    '../../../../../../refactory/modules/jobs/infrastructure/reject-items-post-delivery-incidence/reject-items-post-delivery-creation-view.component'
  )
)
const LazyLoadRejectItemsResolutionPostDelivery = React.lazy(() =>
  import(
    '../../../../../../refactory/modules/jobs/infrastructure/reject-items-post-delivery-incidence/reject-items-post-delivery-resolution-view.component'
  )
)
const LazyLoadTasks = React.lazy(() =>
  import('../../../../../../refactory/tasks/infrastructure/tasks/tasks-view.component')
)

const { Content } = Layout
const HAS_ROUTES = 'hasRoutes'
const HAS_ACCOUNTING = 'hasAccounting'

export default connect()(
  withRouter((props) => {
    const { currentUser, isEnterprise, history, featureFlags } = props
    const { t } = useTranslation()
    const [state, setState] = useState({
      viewToShow: <FlagManagement {...props} />
    })
    const [title, setTitle] = useState('')
    const isCreateRoutingV2Active = useGate('is_create_routing_v2_active').value
    const isSegmenterMenuActive = useGate('segmenter_menu').value
    const isComandaMenuActive = useGate('comanda_menu').value
    const isSageMenuActive = useGate('is_sage_menu_active').value
    const isEcommerceMenuActive = useGate('is_ecommerce_menu_active').value
    const isWmsMenuActive = useGate('is_wms_menu_active').value
    const isActivityLogIsActive = useGate('is_activity_log_is_active').value
    const isMetabaseActive = useGate('is_metabase_active').value
    const isStarStreamActive = useGate('is_star_stream_active').value
    const isNewRejectItemsPostDeliveryActive = useGate('is_new_reject_items_active').value
    const isRoutingByZonesActive = useGate('is_routing_by_zones_active').value

    const getAllowedView = (viewKey) => {
      const views = [
        {
          key: 'orders',
          path: '/orders',
          isAvailable: Can([ModulePerms.JOB])
        },
        {
          key: 'tasks',
          path: '/tasks',
          isAvailable: Can([ModulePerms.TAS])
        },
        {
          key: 'order-incidence-create',
          path: '/orders',
          isAvailable: Can([ModulePerms.JOB]) && isNewRejectItemsPostDeliveryActive
        },
        {
          key: 'order-incidence-resolve',
          path: '/orders',
          isAvailable: Can([ModulePerms.JOB]) && isNewRejectItemsPostDeliveryActive
        },
        {
          key: 'alert-management',
          path: '/alert-management/orders',
          isAvailable: Can([ModulePerms.FLA])
        },
        {
          key: 'routes',
          path: '/routes',
          isAvailable: Can([ModulePerms.ROU]) && featureFlags[HAS_ROUTES] === 'true'
        },
        {
          key: 'metrics',
          path: '/metrics/order-status',
          isAvailable: Can([ModulePerms.MET])
        },
        {
          key: 'analytics',
          path: '/analytics',
          isAvailable: Can([ModulePerms.ANA]) && isMetabaseActive
        },
        {
          key: 'users',
          path: '/user-management/users',
          isAvailable: Can([ModulePerms.USE])
        },
        {
          key: 'resources',
          path: '/resources/stores',
          isAvailable: Can([ModulePerms.RES])
        },
        {
          key: 'system-parameters',
          path: '/system-parameters/general',
          isAvailable: Can([ModulePerms.PAR])
        },
        {
          key: 'accounting',
          path: '/accounting',
          isAvailable: Can([ModulePerms.ACC]) && featureFlags[HAS_ACCOUNTING] === 'true'
        },
        {
          key: 'ecommerceAdmin',
          path: '/ecommerceAdmin',
          isAvailable: Can([ModulePerms.ECO]) && isEcommerceMenuActive
        },
        {
          key: 'wms',
          path: '/wms',
          isAvailable: Can([ModulePerms.WMS]) && isWmsMenuActive
        },
        {
          key: 'segmenter',
          path: '/segmenter',
          isAvailable: Can([ModulePerms.SEG]) && isSegmenterMenuActive
        },
        {
          key: 'comanda',
          path: '',
          isAvailable: Can([ModulePerms.COM]) && isComandaMenuActive
        },
        {
          key: 'order-ratings',
          path: '/order-ratings',
          isAvailable: Can([ModulePerms.ORA]) && isSageMenuActive
        },
        {
          key: 'jonah-jameson',
          path: '/jonah-jameson',
          isAvailable: Can([ModulePerms.JJS])
        },
        {
          key: 'activity-log',
          path: '/activity-log',
          isAvailable: Can([ModulePerms.LOG]) && isActivityLogIsActive
        },
        {
          key: 'reports',
          path: '/reports',
          isAvailable: Can([ModulePerms.SST]) && isStarStreamActive
        },
        {
          key: 'not-found',
          path: '/not-found',
          isAvailable: true
        }
      ]
      const viewAvailable = views.find((view) => view.key === viewKey)
      const fisrtViewAvailable = views.find((view) => view.isAvailable && view.key !== 'comanda')

      if (viewAvailable.isAvailable) {
        return viewAvailable.key
      } else {
        history.push(fisrtViewAvailable.path)
        return fisrtViewAvailable.key
      }
    }

    useEffect(() => {
      let allowedView = ''
      if (Object.keys(featureFlags).length > 0) {
        allowedView = getAllowedView(props.view)
      } else {
        allowedView = props.view
      }
      const getView = (view) => {
        switch (view) {
          case 'orders':
            setTitle(t('menu.jobs-search'))
            return <LazyLoad component={LazyLoadJobList} {...props} />
          case 'tasks':
            setTitle(t('menu.tasks'))
            return <LazyLoad component={LazyLoadTasks} {...props} />
          case 'order-incidence-create':
            setTitle(t('jobs.rejectItemsView.title'))
            return <LazyLoad component={LazyLoadRejectItemsCreatePostDelivery} {...props} />
          case 'order-incidence-resolve':
            setTitle(t('jobs.rejectItemsView.title'))
            return <LazyLoad component={LazyLoadRejectItemsResolutionPostDelivery} {...props} />
          case 'alert-management':
            setTitle(t('menu.jobs-list'))
            return <LazyLoad component={LazyLoadJobs} {...props} />
          case 'routes':
            setTitle(t('routing-module'))
            return isCreateRoutingV2Active ? (
              <LazyLoad component={isRoutingByZonesActive ? LazyLoadRoutesV2 : LazyLoadRoutesV2Old} {...props} />
            ) : (
              <LazyLoad component={LazyLoadRoutes} {...props} />
            )
          case 'metrics':
            setTitle(t('metrics'))
            return <LazyLoad component={LazyLoadMetrics} {...props} />
          case 'analytics':
            setTitle(t('metabase.analytics'))
            return <LazyLoad component={LazyLoadAnalytics} {...props} />
          case 'users':
            setTitle(t('menu.users'))
            return <LazyLoad component={LazyLoadUsers} {...props} />
          case 'resources':
            setTitle(t('menu.resources'))
            return <LazyLoad component={LazyLoadResources} {...props} />
          case 'system-parameters':
            setTitle(t('systemParameters'))
            return <LazyLoad component={LazyLoadSystemParameters} {...props} />
          case 'accounting':
            setTitle('Accounting')
            return <LazyLoad component={LazyLoadMFE} {...props} />
          case 'ecommerceAdmin':
            setTitle('Ecommerce admin')
            return <LazyLoad component={LazyLoadMFEVSN} {...props} />
          case 'wms':
            setTitle('WMS')
            return <LazyLoad component={LazyLoadMFEWMS} {...props} />
          case 'segmenter':
            setTitle('Segmenter')
            return <LazyLoad component={LazyLoadMFESegmenter} {...props} />
          case 'comanda':
            setTitle('Comanda')
            return <LazyLoad component={LazyLoadMFEComanda} {...props} />
          case 'order-ratings':
            setTitle(t('order-ratings'))
            return <LazyLoad component={LazyLoadMFESage} {...props} />
          case 'jonah-jameson':
            setTitle('Jonah jameson')
            return <LazyLoad component={LazyLoadMFEJonahJameson} {...props} />
          case 'activity-log':
            setTitle(t('activityLog.activityLog'))
            return <LazyLoad component={LazyLoadActivityLog} {...props} />
          case 'reports':
            setTitle(t('reports.title'))
            return <LazyLoad component={LazyLoadStartStream} {...props} />
          case 'not-found':
            setTitle('')
            return <LazyLoad component={LazyLoadNotAvailable} {...props} />
          default:
            return <LazyLoad component={LazyLoadNotAvailable} {...props} />
        }
      }

      setState({ viewToShow: getView(allowedView) })
    }, [props.view, currentUser, isEnterprise, props.featureFlags, props, t])

    return (
      <Layout className='main-screen'>
        <SideMenu history={props.history} view={props.view} featureFlags={props.featureFlags} />
        <Layout>
          <Header {...props} title={title} />
          <Content>{state.viewToShow}</Content>
        </Layout>
      </Layout>
    )
  })
)
